import { useContext } from 'react'

import { RequestUserConfigContext } from '@src/context/request-user-config'

export const useRequestUserConfigContext = () => {
    const requestUserConfigContext = useContext(RequestUserConfigContext)
    return requestUserConfigContext
}
